import { render, staticRenderFns } from "./SelectedLatestVacancyDetail.vue?vue&type=template&id=cbe55b6c&"
import script from "./SelectedLatestVacancyDetail.vue?vue&type=script&lang=js&"
export * from "./SelectedLatestVacancyDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports